/**
 * Layout persistence: server (`/api/dashboard/layout/`, per user + organization) with a
 * localStorage copy for the first paint. The server always wins.
 */
import axios from 'axios';

const localKey = (orgId) => `dashboard_layout_${orgId}`;

export async function getLayout(orgId) {
  const response = await axios.get('/api/dashboard/layout/', { params: { organization: orgId } });
  return response.data;
}

export async function putLayout(orgId, layout) {
  const response = await axios.put(`/api/dashboard/layout/?organization=${orgId}`, layout);
  return response.data;
}

export function readLocalLayout(orgId) {
  if (!orgId) return null;
  try {
    const raw = localStorage.getItem(localKey(orgId));
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

export function writeLocalLayout(orgId, layout) {
  if (!orgId) return;
  try {
    if (layout) localStorage.setItem(localKey(orgId), JSON.stringify(layout));
    else localStorage.removeItem(localKey(orgId));
  } catch (error) {
    /* storage disabled or full: the server copy is authoritative anyway */
  }
}
